// EventBus
import maEventbus from '@/components/eventbus'

// components
import maInputText from '@/components/input/modules/text'
import maInputTextNumbers from '@/components/input/modules/text-numbers'
import maInputSelect from '@/components/input/modules/select'
import maInputRadio from '@/components/input/modules/radio'
import maInputCheckbox from '@/components/input/modules/checkbox'
import maInputTextmap from '@/components/input/modules/textmap'
import maInputTextmapline from '@/components/input/modules/textmapline'
import maInputImgradio from '@/components/input/modules/imgRadio'
import maInputSelectMap from '@/components/input/modules/selectmap'
import maInputBtn from '@/components/input/modules/btn'
import maInputFile from '@/components/input/modules/fileImg'

// vuex
import { mapState } from 'vuex'

// types
import { WARRANTY_MODULE_NAME } from '@/store/types'

// import event Bus
import maEventBus from '@/components/eventbus/index.js'

/**
 * @module
 * @name Form
 * @description Dynamic form
 */
export default {
  name: 'Form',
  /**
   * @property {String} type CSS style
   * @property {Object} formData Form components will be rendered according
   *                             to this object.
   */
  props: {
    type: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: false
    },
    handleChangeFile: {
      type: Function,
      required: false
    },
    titleFileInputEnsemble: {
      type: String,
      required: false
    },
    nameFileInputEnsemble: {
      type: String,
      required: false
    },
    inputImgListEnsemble: {
      type: Array,
      required: false
    },
    titleFileInputPres: {
      type: String,
      required: false
    },
    nameFileInputPres: {
      type: String,
      required: false
    },
    inputImgListPres: {
      type: Array,
      required: false
    }
  },

  components: {
    maInputText,
    maInputTextNumbers,
    maInputSelect,
    maInputRadio,
    maInputCheckbox,
    maInputTextmap,
    maInputTextmapline,
    maInputImgradio,
    maInputSelectMap,
    maInputBtn,
    maInputFile
  },

  /**
   * @property {Boolean} agentView From state, it shows different input components
   *                               depending on if we're working with agentView
   *                               or not.
   * @property {Object} stateWarrantyCoordinates Retrieved from state, set in
   *                                             sinister address for inputs that
   *                                             need it.
   */
  computed: {
    ...mapState({
      agentView: (state) => state.agentView
    }),
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyCoordinates: 'coordinates'
    })
  },
  methods: {
    /**
     * @function
     * @name handleChangeView
     * @description Emits and event to resize accordion
     * @fires accordion:resize
     */
    handleChangeView: function () {
      setTimeout(() => {
        maEventBus.$emit('accordion:resize')
      }, 600)
    },
    /**
     * @function
     * @name handleEvent
     * @description Wrapper that emits and event including if hasNestedComponents,
     *              and inputId, inputVal of the input that emit an event.
     * @param {String} action input, change... basically event method.
     * @param {Boolean} hasNestedComponents If there are nested components, form
     *                                      should be refreshed.
     * @param {Boolean} inputId Input id of transmitter event input.
     * @param {Boolean} inputVal Input value of transmitter event input.
     * @return {Object}
     */
    handleEvent: function (action, hasNestedComponents, inputId, inputVal) {
      this.$emit(action, {
        hasNestedComponents,
        inputId,
        inputVal
      })
    },
    /**
     * @function
     * @name handleEventTextNumber
     * @description Wrapper that emits and event including if hasNestedComponents,
     *              and inputId, inputVal of the input that emit an event.
     * @param {String} action input, change... basically event method.
     * @param {Boolean} hasNestedComponents If there are nested components, form
     *                                      should be refreshed.
     * @param {Boolean} inputId Input id of transmitter event input.
     * @param {Boolean} inputVal Input value of transmitter event input.
     * @param {Boolean} inpTextNumbers Input type

     * @return {Object}
     */
    handleEventTextNumber: function (
      action,
      hasNestedComponents,
      inputId,
      inputVal,
      inpTextNumbers
    ) {
      this.$emit(action, {
        hasNestedComponents,
        inputId,
        inputVal,
        inpTextNumbers
      })
    },
    /* handleFileChangeImaEnsemble (fileData) {
      this.$emit('file:change-ensemble', { fileData })
    }, */
    handleFileChangeImgPres(fileData) {
      this.$emit('file:change-pres', { fileData })
    }
  },
  mounted: function () {
    maEventbus.$on('view:change', () => {
      this.handleChangeView()
    })
  }
}
